import MAP_STYLES from './styles';
export var getMapOptions = function getMapOptions(lat, lng) {
  var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;
  return {
    center: {
      lat: lat !== null && lat !== void 0 ? lat : 0,
      lng: lng !== null && lng !== void 0 ? lng : 0
    },
    mapMaker: true,
    zoomControl: false,
    fullscreenControl: false,
    clickableIcons: false,
    gestureHandling: 'none',
    zoom: zoom !== null && zoom !== void 0 ? zoom : 15,
    styles: MAP_STYLES
  };
};
export var getKey = function getKey() {
  return window.gmaps_key || '';
};